import { render } from "./Polls.vue?vue&type=template&id=afe621bc&scoped=true"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"

import "./Polls.vue?vue&type=style&index=0&id=afe621bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe621bc"]])

export default __exports__